import { render, staticRenderFns } from "./addCallRecording.vue?vue&type=template&id=48988ec9&"
import script from "./addCallRecording.vue?vue&type=script&lang=js&"
export * from "./addCallRecording.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports